import { render, staticRenderFns } from "./lingdongList.vue?vue&type=template&id=37aeb1ea"
import script from "./lingdongList.vue?vue&type=script&lang=js"
export * from "./lingdongList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports